module.exports = __webpack_public_path__ + "img/2.9436381b.jpg";